module.exports = __webpack_public_path__ + "assets/img/banner-11.7bb5fe54.png";